export interface BrandingColors {
  black?: string;
  lightGray1?: string;
  lightGray2?: string;
  white?: string;
  background?: string;
  foreground?: string;
  accent?: string;
  gray?: string;
  glassBg?: string;
  glassBorder?: string;
  glassShine?: string;
}

export type DomainStatus = "None" | "Pending" | "Verified" | "Failed";

export interface TenantBranding {
  tenantId: string;
  appName: string | null;
  logoUrl: string | null;
  faviconUrl: string | null;
  colors: BrandingColors;
  customDomain: string | null;
  domainStatus: DomainStatus;
  verificationRecordName: string | null;
  verificationRecordValue: string | null;
  domainVerifiedAt: string | null;
}

export interface PublicBranding {
  appName: string | null;
  logoUrl: string | null;
  faviconUrl: string | null;
  colors: BrandingColors;
}

/** Maps a BrandingColors key to its CSS custom property in index.css. */
export const COLOR_VAR_MAP: Record<keyof BrandingColors, string> = {
  black: "--color-black",
  lightGray1: "--color-light-gray-1",
  lightGray2: "--color-light-gray-2",
  white: "--color-white",
  background: "--color-background",
  foreground: "--color-foreground",
  accent: "--color-accent",
  gray: "--color-gray",
  glassBg: "--color-glass-bg",
  glassBorder: "--color-glass-border",
  glassShine: "--color-glass-shine",
};
